import * as v from 'valibot';

export const userStatusResponseSchema = v.object({
	userId: v.string(),
	displayName: v.string(),
	availableBalance: v.number(),
	committedBalance: v.number(),
	totalBalance: v.number(),
	activeGameIds: v.array(v.string()),
	matchmakingQueueId: v.nullable(v.string()),
	lastActivity: v.pipe(v.string(), v.isoTimestamp()),
});

export type UserStatusResponse = v.InferOutput<typeof userStatusResponseSchema>;
